import { Lead, User } from 'types/user';
import { SeizureFile } from '../ArchivePage/SeizureDetails/hooks';
import { FilePostSeizureDetail } from '../RedemptionPage/PostSeizurePage/Edit/hook';

export const TAB = {
  UPDATES: 'updates',
  SEIZURE_REPORTS: 'seizureReports',
  OUT_OF_LEADS: 'outOfLeads',
  CHAT_BOX: 'chatBox'
} as const;

export type TypeTAB = (typeof TAB)[keyof typeof TAB];

export const headerTab = [
  { label: 'Updates', param: TAB.UPDATES, value: 0 },
  { label: 'Seizure Reports', param: TAB.SEIZURE_REPORTS, value: 1 },
  { label: 'Inbox', param: TAB.CHAT_BOX, value: 2 }
];
export type fileResCommunication = {
  id: number;
  lastCommunicationAt: string;
  createdAt: string;
  lastNoteAt: string;
  updatedAt: string;
  fileNumber: string;
  make: string;
  model: string;
  vin: string;
  year: string;
  firstName: string;
  lastName: string;
  dispatchFiles?: {
    user: {
      role: string;
      firstName: string;
      lastName: string;
      email: string;
    };
  }[];
  clientOption: {
    id: number;
    value: string;
  };
  leads: Partial<Lead>[];
  filePreSeizures?: FilePostSeizureDetail[];
  filePostSeizures?: FilePostSeizureDetail[];
  seizureReports?: SeizureReports[];
};
export type SeizureReports = {
  id: number;
  kilometers: number;
  hasKey: boolean;
  run: boolean;
  signedVsa: boolean;
  possibleRedemption: boolean;
  postalCode?: string;
  conditionReport: string;
  towingCompany: string;
  transportRequired: boolean;
  billsIncurred: boolean;
  otherAddress?: string;
  otherCustomerPOR?: string;
  addressLeadId: string;
  otherTransport: string;
  otherBills: string;
  customersLeadId: string;
  removedToId: number;
  removedToOther?: string;
  createdAt?: string;
  createdBy?: User;
  addressLead: {
    address: string;
  };
  customersLead: {
    address: string;
  };
  removedToLocation: {
    value: string;
  };
  seizureReportPhotos: SeizureFile[];
  vsaDocuments: SeizureFile[];
};
export type TDateCommunication = {
  startDate?: string | null;
  endDate?: string | null;
};
export type CommunicationUpdate = { total: number; updates: fileResCommunication[] };
export type Communication = {
  updates: CommunicationUpdate;
  seizureReports: CommunicationUpdate;
  outOfLeads: CommunicationUpdate;
};
export type DateCommunication = {
  updates: TDateCommunication | null;
  seizureReports: TDateCommunication | null;
  outOfLeads: TDateCommunication | null;
};
